export function decodeJwt<T = any>(token: string): T {
  return JSON.parse(atob(token.split('.')[1]))
}
